<template>
  <transition
    name="el-zoom-in-top"
    @after-leave="doDestroy"
  >
    <div
      v-show="showPopper"
      :class="{ 'is-loading': !parent.hideLoading && parent.loading }"
      :style="{ width: dropdownWidth }"
      class="rt-autocomplete-suggestion el-autocomplete-suggestion el-popper"
      role="region"
    >
      <el-scrollbar
        tag="ul"
        wrap-class="el-autocomplete-suggestion__wrap"
        view-class="el-autocomplete-suggestion__list"
      >
        <li v-if="!parent.hideLoading && parent.loading">
          <i class="el-icon-loading"></i>
        </li>
        <slot v-else>
        </slot>
      </el-scrollbar>
    </div>
  </transition>
</template>
<script>
import Popper from 'element-ui/lib/utils/vue-popper';
import Emitter from 'element-ui/lib/mixins/emitter';
import ElScrollbar from '../../scrollbar';

export default {
  components: { ElScrollbar },
  mixins: [Popper, Emitter],

  componentName: 'ElAutocompleteSuggestions',

  props: {
    // eslint-disable-next-line vue/require-prop-types
    options: {
      default () {
        return {
          gpuAcceleration: false
        };
      }
    },
    id: String
  },

  data () {
    return {
      parent: this.$parent,
      dropdownWidth: ''
    };
  },

  inject: {
    rtLookup: {
      default: ''
    }
  },

  updated () {
    this.$nextTick(_ => {
      this.popperJS && this.updatePopper();
    });
  },

  mounted () {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = (this.rtLookup && this.rtLookup.$refs.lookup) || this.$parent.$refs.input.$refs.input || this.$parent.$refs.input.$refs.textarea;
    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
    this.referenceList.setAttribute('role', 'listbox');
    this.referenceList.setAttribute('id', this.id);
  },

  created () {
    this.$on('visible', (val, inputWidth) => {
      const lookup = this.rtLookup && this.rtLookup.$refs.lookup
      const dropdownWidth = (lookup && lookup.offsetWidth) || inputWidth;
      this.dropdownWidth = dropdownWidth + 'px';
      this.showPopper = val;
    });
  },

  methods: {
    select (item) {
      this.dispatch('ElAutocomplete', 'item-click', item);
    }
  }
};
</script>



// WEBPACK FOOTER //
// autocomplete-suggestions.vue?1f2fde49